import React from "react";
import { Modal } from "react-bootstrap";

export default function ResponsiveBrokerModal({ show, onHide }) {
    return (
        <Modal size="md" aria-labelledby="contained-modal-title-vcenter" className="modal-details broker-modal" show={show} centered>
            <Modal.Header className="justify-content-between">
                <Modal.Title>Responsive Broker</Modal.Title>
                <button type="button" onClick={onHide} className="close-icon-style">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body>
                <span className="modal-desc">
                    Agents with the Responsive Broker badge have demonstrated that they are highly responsive, easily reachable, and consistently available to assist clients.
                </span>
            </Modal.Body>
        </Modal>
    );
}
